import React, { useRef, useState, useEffect } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, c as _slicedToArray, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: 100%;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  opacity: ", ";\n\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 100;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledInputPopdownContainer = styled.div(_templateObject());
var StyledInputPopdown = styled.div(_templateObject2(), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'block' : 'none';
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? '1' : '0';
});
var StyledInputPopdownEnhancerContainer = styled.div(_templateObject3(), function (_ref3) {
  var theme = _ref3.theme;
  return "\n    background: ".concat(theme.components.inputPopdown.colors.background, ";\n    box-shadow: ").concat(theme.components.inputPopdown.boxShadows.boxShadow, ";\n    border-radius: ").concat(theme.components.inputPopdown.borders.radius, ";\n  ");
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Enhance any input with a dropdown on focus
 */

var InputPopdown = function InputPopdown(_ref) {
  var children = _ref.children,
      enhancer = _ref.enhancer,
      rest = _objectWithoutProperties(_ref, ["children", "enhancer"]);

  var componentRef = useRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  useEffect(function () {
    var handleClickOutside = function handleClickOutside(e) {
      if (isOpen) {
        if (!componentRef.current.contains(e.target)) {
          setIsOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return React.createElement(StyledInputPopdownContainer, _extends({
    onFocus: function onFocus() {
      return setIsOpen(true);
    },
    ref: componentRef
  }, rest), children, React.createElement(StyledInputPopdown, {
    isOpen: isOpen
  }, React.createElement(StyledInputPopdownEnhancerContainer, null, enhancer())));
};

InputPopdown.propTypes = {
  children: PropTypes.element.isRequired,
  enhancer: PropTypes.func.isRequired
};
/** @component */

var index = styled(InputPopdown)(_templateObject$1());

export default index;
